import { render } from "./SystemImage.vue?vue&type=template&id=07c7fb74&scoped=true"
import script from "./SystemImage.vue?vue&type=script&lang=js"
export * from "./SystemImage.vue?vue&type=script&lang=js"

import "./SystemImage.vue?vue&type=style&index=0&id=07c7fb74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c7fb74"]])

export default __exports__